import React, { useEffect, useState } from 'react';
import { obtenerRecursosAyuda, moduloDeVista } from '../services/ayudaService';
import VideoAyudaModal from './VideoAyudaModal';

// "¿Cómo funciona?": aparece arriba de cada módulo SOLO si ese módulo ya tiene
// video en Herramientas y Ayuda. Si no hay video (o no hay internet), no se ve nada.
export default function BotonComoFunciona({ vista }) {
  const [videos, setVideos] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const modulo = moduloDeVista(vista);

  useEffect(() => {
    let vivo = true;
    setVideos([]);
    setAbierto(false);
    if (!modulo) return undefined;
    obtenerRecursosAyuda()
      .then((todos) => { if (vivo) setVideos(todos.filter((r) => r.tipo === 'video' && r.activo && r.modulo === modulo)); })
      .catch(() => {});
    return () => { vivo = false; };
  }, [modulo]);

  if (!videos.length) return null;
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0 0 8px' }}>
        <button type="button" onClick={() => setAbierto(true)} className="k-btn-soft"
          style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontWeight: 700 }}>
          ▶️ ¿Cómo funciona?
        </button>
      </div>
      {abierto && <VideoAyudaModal videos={videos} onCerrar={() => setAbierto(false)} />}
    </>
  );
}
